module.exports = __webpack_public_path__ + "static/media/app-kidsignsay.955db14e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app-kidsignsay.png
// module id = 37
// module chunks = 0